// extracted by mini-css-extract-plugin
export default {"companyContainer":"mO-z","companyImage":"nO-z","container":"oO-z","heading":"pO-z","darkText":"qO-z","smallHeading":"rO-z","darkBackground":"sO-z","whiteBackground":"tO-z"};